<template>
  <layout-editor-page
    :title="formTitle"
    isTabsPage
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <template v-slot:top-controls>
      <div class="control btn-mobile-full" v-if="hasCreateNew">
        <button
          v-if="isAllowToEditRFQs"
          type="button"
          class="btn btn-size-s btn-mobile-full"
          @click="handlerQuickRFQ"
        >
          {{L10n('quick-rfq')}}
        </button>
      </div>
      <div class="control btn-mobile-full" v-if="hasCreateNew">
        <button
          type="button"
          class="btn btn-size-s btn-mobile-full"
          @click="onOpenPdf"
        >
          {{L10n('open-pdf')}}
        </button>
      </div>
    </template>
    <el-tabs v-model="activeTab">
      <el-tab-pane name="general">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('general')}}</span>
        </template>
        <layout-scroll-content>
          <form-general
            :disabled="disabled"
            :is-new="!hasCreateNew"
            ref="Form"
            :data="data"
            :model="formModel"
            @updateModelItem="handlerUpdateModelItem"
            @change="handleFormData"/>
          <template v-slot:footer>
            <form-controls
              class="form-footer"
              :isCreate="!hasCreateNew && !disabled"
              :isSave="hasCreateNew && !disabled"
              :isDelete="hasCreateNew && !disabled"
              @command="setCommand"/>
          </template>
        </layout-scroll-content>
      </el-tab-pane>
      <el-tab-pane
        v-if="isAllowToViewRFQs"
        name="supplier"
        :disabled="!hasCreateNew">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('supplier-quotes')}}</span>
        </template>
        <supplier-quotes
          :editorID="config.id"
          :partID="currentID"
          @on-quick-rfq="handlerQuickRFQ"
        />
      </el-tab-pane>
      <el-tab-pane name="stocks" :disabled="!hasCreateNew">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('stocks')}}</span>
        </template>
        <stocks-grid
          :partID="currentID"
          @on-quick-rfq="handlerQuickRFQ"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="isAllowToViewRFQs"
        name="rfq1s"
        :disabled="!hasCreateNew">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('rfq-rfq1')}}</span>
        </template>
        <rfq1s-grid
          :editorID="config.id"
          :partID="currentID"/>
      </el-tab-pane>
      <el-tab-pane
        v-if="isAllowToViewRFQs"
        name="rfq3s"
        :disabled="!hasCreateNew"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('quote-rfq3')}}</span>
        </template>
        <rfq3s-grid
          :editorID="config.id"
          :partID="currentID"/>
      </el-tab-pane>
      <el-tab-pane name="fleets" :disabled="!hasCreateNew || !formData.aircraftID">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('fleets')}}</span>
        </template>
        <fleets-grid
          :aircraftID="formData.aircraftID"
          :editorID="config.id"
        ></fleets-grid>
      </el-tab-pane>
      <el-tab-pane name="po-wo-hist" >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('po-wo-hist')}}</span>
        </template>
        <po-wo-history
          :partID="currentID"
        />
      </el-tab-pane>
    </el-tabs>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
const PDF_URL = '/pdf/Component_Reliability_Report_2023-01.pdf'

export default {
  name: 'EditorPart',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'form-general': () => import(/* webpackChunkName: 'Parts' */ './FormGeneral'),
    'fleets-grid': () => import(/* webpackChunkName: 'Parts' */ './FleetsParts/Index'),
    'rfq1s-grid': () => import(/* webpackChunkName: 'Parts' */ './RFQ1sParts/Index'),
    'rfq3s-grid': () => import(/* webpackChunkName: 'Parts' */ './RFQ3sParts/Index'),
    'stocks-grid': () => import(/* webpackChunkName: 'Parts' */ './StocksPart/Index'),
    'supplier-quotes': () => import(/* webpackChunkName: 'Parts' */ './SupplierQuotes/Index'),
    'po-wo-history': () => import(/* webpackChunkName: 'Parts' */ './PoWoHistory')
  },
  computed: {
    formTitle () {
      let titles = []
      this.formData.partNumber && titles.push(this.formData.partNumber)
      this.formData.partDescription && titles.push(this.formData.partDescription)
      return titles.join(' - ') || this.checkEs6AndRun(this.title)
    },
    isAllowToViewRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToViewRFQs')
    },
    isAllowToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    }
  },
  data () {
    return {
      activeTab: 'general',
      // eslint-disable-next-line
      apiPatch: 'Parts/Patch/${data.id}'
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        partNumber: '',
        partDescription: '',
        manufacturerID: null,
        aircraftID: null,
        listPrice: '',
        listPriceSource: '',
        priceCurrencyID: null,
        listPriceDate: '',
        remark: '',
        technicalRemark: ''
      }
    },
    handlerQuickRFQ (row) {
      this.$emit('on-quick-rfq', { row: { ...row, id: this.currentID } })
    },
    onOpenPdf () {
      window.open(PDF_URL, '_blank')
    },
    handleChangeID () {
      this.activeTab = 'general'
    }
  }
}
</script>

<style lang="stylus">
  .grid-parts__wrap-inner-tools{
    height 100%
    .grid-tools-wrap{
      .tool-controls{
        display flex
        align-items flex-start
        flex-wrap wrap
        justify-content flex-end
        > li {
          margin: 1.8rem 0 0 0 !important;
          padding: 0 0 0 0.5rem;
        }
      }
    }
    .inner-tool-controls{
      position relative
      z-index 11
    }
  }
  @media only screen and (max-width: 576px) {
    .grid-parts__wrap-inner-tools{
      .grid-tools-wrap{
        flex-direction column
        .grid-toolbar{
          order 2
        }
        .tool-controls{
          order 1
          > li {
            width 100%
            margin 0 0 1rem 0 !important
            > .btn {
              width 100%
            }
          }
        }
      }
    }
  }
</style>
